import apiClient from './api';

export const adminService = {

  // (opcional) Histórico de registros do usuário
  async listFuncionarios() {
    return apiClient.get('/admin/funcionarios');
  },
  
  listLocalizacoes() {
    return apiClient.get('/admin/localizacao');
  },

  obterLocalizacaoPorId(localId) {
    return apiClient.get(`/admin/localizacao/obter/${localId}`);
  },

  atribuirFuncionariosLocalizacao(loc_id, funcionarios) {
    const payload = {
      loc_id,
      funcionarios
    };
    return apiClient.post('/admin/localizacao/atribuir_funcionarios', payload);
  },

  listarFuncionariosPorLocalizacao(localId) {
    return apiClient.get(`/admin/localizacao/${localId}/funcionarios`);
  },

  removerFuncionarioDaLocalizacao(localId, usuarioId) {
    return apiClient.delete(`/admin/localizacao/${localId}/funcionarios/${usuarioId}`);
  },

  createLocalizacao(data) {
    return apiClient.post('/admin/localizacao', data);
  },

  atribuirLocalizacao(payload) {
    return apiClient.post('/admin/atribuir_local', payload)
  },

  deletarLocalizacao(id) {
    return apiClient.delete(`/admin/localizacao/${id}`);
  },

  async createFuncionario(data) {
    return apiClient.post('/admin/funcionarios', data);
  },

  async obterFuncionarioPorId(userId) {
    return apiClient.get(`/admin/funcionarios/${userId}`);
  },

  async atualizarFuncionario(userId, data) {
    return apiClient.put(`/admin/funcionarios/${userId}`, data);
  },

  async deletarFuncionario(userId) {
    return apiClient.delete(`/admin/funcionarios/${userId}`);
  },

  async getDashboardStats() {
    return apiClient.get('/admin/dashboardstatus');
  },
  async getPontosPorPeriodo(user_id, start, end) {
    return apiClient.get('/admin/funcionarios/pontos/obter', {
      params: { user_id, start, end }
    });
  },

  async getRelatorioPorPeriodo(user_id, start, end) {
    return apiClient.get('/admin/funcionarios/pontos/relatorio', {
      params: { user_id, start, end }
    });
  },

  async getEspelhoPonto(user_id, start, end) {
    return apiClient.get('/admin/funcionarios/pontos/espelho', {
      params: { user_id, start, end }
    });
  },

  async ajustar_saida(user_id, data_ajuste) {
    return apiClient.get('/admin/ajustar_saida', {
      params: { user_id, data_ajuste }
    });
  },

  async getSelfie(file_key) {
    return apiClient.get('/admin/obter_selfie', {
      params: { file_key }
    });
  },

  async listCalendarioPeriodo(start, end) {
    return apiClient.get('/admin/calendar/list', {
      params: { start, end }
    });
  },

  async atualizarFeriado(data) {
    return apiClient.put(`/admin/calendar/feriado`, data);
  }



};
